// extracted by mini-css-extract-plugin
module.exports = {"label":"styles-module--label--1_zkn"};